export const StartRouteName = 'start';
export const StepsRouteName = 'steps';
export const VerificationRouteName = 'verification';
export const FinalizeRouteName = 'finalize';
export const CongratulationsRouteName = 'congratulations';
export const RepatriateRouteName = 'repatriate';
export const ShortMessageSystemRouteName = 'sms';
export const ConfirmationRouteName = 'confirmation';
